import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import DefaultStyles from './DefaultStyles';
import {withStyles} from '@material-ui/styles';

class CheckboxValueSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchKey: null,
      selectedItems: props.selectedItems || []
    };
  }

  isChecked(item, selectedItems) {
    const valueFilter = _.filter(selectedItems, function(selectedItem) {
      return selectedItem === item;
    });
    return !_.isEmpty(valueFilter);
  }

  renderSearchBar() {
    const { classes, searchBarLabel, disabled } = this.props;
    const { searchKey } = this.state;

    if (_.isNil(searchBarLabel) || disabled) return;

    const handleSearchChange = event => {
      this.setState({ searchKey: _.lowerCase(event.target.value) });
    };

    return (
      <React.Fragment>
        <Grid item xs={12} className={classes.listSearchBar}>
          <TextField
            fullWidth
            placeholder={searchBarLabel}
            className={classes.listSearchBarText}
            value={searchKey || ""}
            onChange={handleSearchChange}
            InputProps={
              !_.isNil(this.state.searchKey) && this.state.searchKey !== ""
                ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="Clear search bar"
                          onClick={() => {
                            this.setState({ searchKey: null });
                          }}
                        >
                          <Close />
                        </IconButton>
                      </InputAdornment>
                    )
                  }
                : null
            }
          />
        </Grid>
      </React.Fragment>
    );
  }

  renderSelectAll() {
    const {
      classes,
      listItems,
      selectAllLabel,
      onChange,
      checkedIcon,
      icon,
      disabled,
      limit
    } = this.props;
    const { selectedItems } = this.state;

    if (_.isNil(selectAllLabel) || !_.isNil(limit)) return;

    const handleSelectAllChange = event => {
      let newSelectedItems = [];
      if (event.target.checked) {
        newSelectedItems = _.clone(listItems);
      }
      onChange(newSelectedItems);
      this.setState({ selectedItems: newSelectedItems });
    };

    return (
      <div className={classes.listItem}>
        <FormControlLabel
          control={
            <Checkbox
              className={classes.listItemCheckbox}
              disableRipple
              color="default"
              checked={_.isEqual(selectedItems, listItems)}
              onChange={handleSelectAllChange}
              disabled={disabled}
              checkedIcon={checkedIcon}
              icon={icon}
            />
          }
          className={classes.listItemCheckbox.label}
          label={selectAllLabel}
        />
      </div>
    );
  }

  renderStatusBar() {
    const { selectedItems } = this.state;
    const { limit } = this.props;

    let status = `${selectedItems.length} item${
      selectedItems.length !== 1 ? "s are" : " is"
    } currently selected.`;

    if (limit) {
      status =
        status +
        ` You can only select ${limit.max} ${
          limit.max > 1 ? "items" : "item"
        }.`;
    }

    return status;
  }

  renderValueCheckbox(item) {
    const { classes, checkedIcon, icon, disabled, onChange, limit } = this.props;
    const { selectedItems } = this.state;

    const handleChange = item => event => {
      const { selectedItems } = this.state;
      let newSelectedItems = selectedItems;
      if (event.target.checked) {
        if (limit && limit.max === newSelectedItems.length) {
          newSelectedItems.splice(limit.deleteLast ? limit.max - 1 : 0, 1);
        }
        newSelectedItems.push(item);
      } else {
        _.remove(newSelectedItems, function(listItem) {
          return item === listItem;
        });
      }

      onChange(newSelectedItems);
      this.setState({ selectedItems: newSelectedItems });
    };

    return (
      <div className={classes.listItem} key={`div-${item}`}>
        <FormControlLabel
          control={
            <Checkbox
              className={classes.listItemCheckbox}
              disabled={disabled}
              disableRipple
              color="default"
              checked={this.isChecked(item, selectedItems)}
              onChange={handleChange(item)}
              checkedIcon={checkedIcon}
              icon={icon}
            />
          }
          className={classes.listItemCheckbox.label}
          label={item}
        />
      </div>
    );
  }

  renderCheckboxes() {
    const { selectedItems, searchKey } = this.state;
    const { listItems, selectedItemsFirst } = this.props;

    const filteredListItems = _.orderBy(
      searchKey && searchKey !== ""
        ? _.filter(listItems, listItem => {
            return _.startsWith(_.lowerCase(listItem), searchKey);
          })
        : selectedItemsFirst && !_.isEmpty(selectedItems)
        ? _.filter(listItems, listItem => {
            return _.isNil(
              _.find(selectedItems, selectedItem => {
                return selectedItem === listItem;
              })
            );
          })
        : listItems
    );

    return (
      <React.Fragment>
        {selectedItemsFirst &&
          (_.isNil(searchKey) || searchKey === "") &&
          !_.isEmpty(selectedItems) &&
          _.orderBy(selectedItems).map(item => {
            return this.renderValueCheckbox(item);
          })}
        {filteredListItems.map(item => {
          return this.renderValueCheckbox(item);
        })}
      </React.Fragment>
    );
  }

  render() {
    const { classes, label, statusBar } = this.props;
    console.log(classes.listLabel);

    return (
      <Grid container direction="row" alignItems="stretch" className={classes.root}>
        {label && (
          <Grid item xs={12} className={classes.listLabel}>
            {label}
          </Grid>
        )}
        {statusBar && (
          <Grid item xs={12} className={classes.listStatusBar}>
            {this.renderStatusBar()}
          </Grid>
        )}
        {this.renderSearchBar()}
        <Grid item xs={12} className={classes.listContainer}>
          {this.renderSelectAll()}
          {this.renderCheckboxes()}
        </Grid>
      </Grid>
    );
  }
}

CheckboxValueSelect.propTypes = {
  checkedIcon: PropTypes.object,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  icon: PropTypes.object,
  label: PropTypes.string,
  limit: PropTypes.shape({
    max: PropTypes.number.isRequired,
    deleteLast: PropTypes.bool.isRequired
  }),
  listItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  searchBarLabel: PropTypes.string,
  selectAllLabel: PropTypes.string,
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  selectedItemsFirst: PropTypes.bool,
  statusBar: PropTypes.bool,
};

CheckboxValueSelect.defaultProps = {
  disabled: false,
  selectAll: true,
  statusBar: false,
  selectedItemsFirst: false,
};

export default withStyles(DefaultStyles)(CheckboxValueSelect);
